module.exports = __webpack_public_path__ + "static/Eonix_Stories-91cb9646e0f25bd7d92bd8d2584d8205.jpg";